/**
 * Adds a number of business days (Mon-Fri) to a date, skipping weekends.
 * @param {Date} date
 * @param {number} days
 * @returns {Date}
 */
function addBusinessDays(date, days) {
  const result = new Date(date);
  let added = 0;

  while (added < days) {
    result.setDate(result.getDate() + 1);
    const weekday = result.getDay();
    if (weekday !== 0 && weekday !== 6) added += 1;
  }

  return result;
}

/**
 * Renders an estimated delivery date range (e.g. "Recibe tu pedido entre el 28 de agosto y el 2 de
 * septiembre.") based on a minimum/maximum number of business days from today.
 *
 * @typedef {object} DeliveryEstimateDataset
 * @property {string} minDays
 * @property {string} maxDays
 * @property {string} template
 * @extends HTMLElement
 */
class DeliveryEstimate extends HTMLElement {
  static get observedAttributes() {
    return ['data-min-days', 'data-max-days', 'data-template'];
  }

  connectedCallback() {
    this.render();
  }

  attributeChangedCallback() {
    this.render();
  }

  render() {
    const minDays = Number(this.dataset.minDays);
    const maxDays = Number(this.dataset.maxDays);
    const template = this.dataset.template;

    if (!minDays || !maxDays || !template) {
      this.textContent = '';
      return;
    }

    const today = new Date();
    const start = addBusinessDays(today, minDays);
    const end = addBusinessDays(today, maxDays);
    const locale = document.documentElement.lang || 'es';
    const formatter = new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long' });

    this.textContent = template
      .replace('{{ start_date }}', formatter.format(start))
      .replace('{{ end_date }}', formatter.format(end));
  }
}

if (!customElements.get('delivery-estimate')) {
  customElements.define('delivery-estimate', DeliveryEstimate);
}
